import PropTypes from 'prop-types';
import { IconButton } from "@mui/material";
import Iconify from '../../components/iconify';
import { newFDate, fDateTimeNewHours } from '../../utils/formatTime';
import UserMasterMoreMenu from '../usermasterlist/usermastermoremenu';

// --------------------------------------------------------------------------------------------------------

export default function MasterDataDef(masterName) {
    const columnMaps = new Map();

    // Import history'
    const importrowHistoryColumns = [
        { field: 'changedDate', headerName: 'Activity date', width: 150, description: 'Activity date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'operation', headerName: 'Operation', width: 100, description: 'Operation performed' },
        { field: 'changedBy', headerName: 'By', width: 150, description: 'The operation performed by' },
        { field: 'reason', headerName: 'Reason', width: 200, description: 'Import / delete reason' },
        { field: 'effectiveFromDate', headerName: 'Effective date', width: 135, description: 'Effective from date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('importrowhistory', importrowHistoryColumns);

    const importrowHistory2Columns = [
        { field: 'changedDate', headerName: 'Activity date', width: 150, description: 'Activity date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'operation', headerName: 'Operation', width: 100, description: 'Operation performed' },
        { field: 'changedBy', headerName: 'By', width: 150, description: 'The operation performed by' },
        { field: 'reason', headerName: 'Reason', width: 200, description: 'Import / delete reason' },
    ];

    columnMaps.set('importrowhistory2', importrowHistory2Columns);

    // Import history'
    const importHistoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'changedDate', headerName: 'Import Date', width: 120, description: 'Import Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
        { field: 'importFileName', headerName: 'File Name', width: 130, description: 'File Name' },
        { field: 'reason', headerName: 'Description', width: 800, description: 'Description' },
        { field: 'changedBy', headerName: 'Imported By', width: 120, description: 'Imported By' },
    ];

    columnMaps.set('importhistory', importHistoryColumns);


    // Distributor master
    const distributorColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Code', width: 55, description: 'Distributor code' },
        { field: 'distributorName', headerName: 'Name', width: 200, description: 'Distributor Name' },
        { field: 'distributorAlias', headerName: 'Alias', width: 55, description: 'Distributor Alias' },
        { field: 'distributorGroup', headerName: 'Group', width: 100, description: 'Distributor Group' },
        { field: 'isActive', headerName: 'Active', width: 60, description: 'Is Active' },
        { field: 'isValidated', headerName: 'Validated', width: 80, description: 'Is Validated' },
        { field: 'validatedFromDate', headerName: 'Validated Date', width: 110, description: 'Validated Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'distributorCity', headerName: 'City', width: 60, description: 'Distributor City' },
        { field: 'distributorState', headerName: 'State', width: 80, description: 'Distributor State' },
        { field: 'distributorRegion', headerName: 'Region', width: 65, description: 'Distributor Region' },
        { field: 'distributorPrimaryEmail', headerName: 'Primary Email', width: 150, description: 'Distributor Primary Email' },
        { field: 'distributorAlternateEmail', headerName: 'Alternate Email', width: 150, description: 'Distributor Alternative Email' },
        { field: 'distributorContactNo', headerName: 'Contact No', width: 90, description: 'Distributor Contact No' },
        { field: 'distributorAlternateContactNo', headerName: 'Alternate Contact No', width: 90, description: 'Distributor Alternate Contact No' },
        { field: 'distributorContactPerson', headerName: 'Contact Person', width: 110, description: 'Distributor Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 110, description: 'Distributor Alternate Contact Person' },
        // { field: 'dataUploadType', headerName: 'Upload Type', width: 150, description: 'Distributor Data Upload Type' },
    ];

    columnMaps.set('distributor', distributorColumns);

    // distributorimportpreview
    const distributorImportPreviewColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'distributorCode', headerName: 'Code', width: 55, description: 'Distributor code' },
        { field: 'distributorName', headerName: 'Name', width: 200, description: 'Distributor Name' },
        { field: 'distributorAlias', headerName: 'Alias', width: 55, description: 'Distributor Alias' },
        { field: 'distributorGroup', headerName: 'Group', width: 100, description: 'Distributor Group' },
        { field: 'isActive', headerName: 'Active', width: 60, description: 'Is Active' },
        { field: 'isValidated', headerName: 'Validated', width: 80, description: 'Is Validated' },
        { field: 'validatedFromDate', headerName: 'Validated Date', width: 110, description: 'Validated Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'distributorCity', headerName: 'City', width: 60, description: 'Distributor City' },
        { field: 'distributorState', headerName: 'State', width: 80, description: 'Distributor State' },
        { field: 'distributorRegion', headerName: 'Region', width: 65, description: 'Distributor Region' },
        { field: 'distributorPrimaryEmail', headerName: 'Primary Email', width: 150, description: 'Distributor Primary Email' },
        { field: 'distributorAlternateEmail', headerName: 'Alternate Email', width: 150, description: 'Distributor Alternative Email' },
        { field: 'distributorContactNo', headerName: 'Contact No', width: 90, description: 'Distributor Contact No' },
        { field: 'distributorAlternateContactNo', headerName: 'Alternate Contact No', width: 90, description: 'Distributor Alternate Contact No' },
        { field: 'distributorContactPerson', headerName: 'Contact Person', width: 110, description: 'Distributor Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 110, description: 'Distributor Alternate Contact Person' },
        //   { field: 'dataUploadType', headerName: 'Upload Type', width: 150, description: 'Distributor Data Upload Type' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('distributorimportpreview', distributorImportPreviewColumns);


    // Product master
    const productColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'productCode', headerName: 'Product Code', width: 100, description: 'Product Code' },
        { field: 'productDescription', headerName: 'Product Description', width: 200, description: 'Product Description' },
        { field: 'uom', headerName: 'UOM', width: 60, description: 'UOM' },
        { field: 'reportingUOM', headerName: 'Reporting UOM', width: 110, description: 'Reporting UOM' },
        { field: 'conversionFactor', headerName: 'Conversion Factor', width: 125, description: 'Conversion Factor' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'Sub Franchise', width: 105, description: 'Sub Franchise' },
        { field: 'productCategory', headerName: 'Product Category', width: 120, description: 'Product Category' },
        { field: 'productBrand', headerName: 'Product Brand', width: 105, description: 'Product Brand' },
        { field: 'productGroup', headerName: 'Product Group', width: 105, description: 'Product Group' },
        { field: 'productLine', headerName: 'Product Line', width: 95, description: 'Product Line' },
        { field: 'isActive', headerName: 'Is Active', width: 75, description: 'Is Active' },
        { field: 'isStrategicProduct', headerName: 'Strategic Product', width: 120, description: 'Strategic Product' },
        { field: 'isInstallationReport', headerName: 'Requires Installation Report', width: 180, description: 'Requires Installation Report' },
        { field: 'bravoHierarchy', headerName: 'Bravo Hierarchy', width: 110, description: 'Bravo Hierarchy' },
        { field: 'dateOfDeactivation', headerName: 'Date of Deactivation', width: 135, description: 'Date of Deactivation', valueFormatter: (params) => newFDate(params.value) },
        { field: 'stdProductCode', headerName: 'Std Product Code', width: 135, description: 'Std Product Code' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('product', productColumns);


    // productimportpreview
    const productImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'productCode', headerName: 'Product Code', width: 100, description: 'Product Code' },
        { field: 'productDescription', headerName: 'Product Description', width: 200, description: 'Product Description' },
        { field: 'uom', headerName: 'UOM', width: 60, description: 'UOM' },
        { field: 'reportingUOM', headerName: 'Reporting UOM', width: 110, description: 'Reporting UOM' },
        { field: 'conversionFactor', headerName: 'Conversion Factor', width: 125, description: 'Conversion Factor' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'Sub Franchise', width: 105, description: 'Sub Franchise' },
        { field: 'productCategory', headerName: 'Product Category', width: 120, description: 'Product Category' },
        { field: 'productBrand', headerName: 'Product Brand', width: 105, description: 'Product Brand' },
        { field: 'productGroup', headerName: 'Product Group', width: 105, description: 'Product Group' },
        { field: 'productLine', headerName: 'Product Line', width: 95, description: 'Product Line' },
        { field: 'isActive', headerName: 'Is Active', width: 75, description: 'Is Active' },
        { field: 'isStrategicProduct', headerName: 'Strategic Product', width: 120, description: 'Strategic Product' },
        { field: 'isInstallationReport', headerName: 'Requires Installation Report', width: 180, description: 'Requires Installation Report' },
        { field: 'bravoHierarchy', headerName: 'Bravo Hierarchy', width: 110, description: 'Bravo Hierarchy' },
        { field: 'dateOfDeactivation', headerName: 'Date of Deactivation', width: 135, description: 'Date of Deactivation', valueFormatter: (params) => newFDate(params.value) },
        { field: 'stdProductCode', headerName: 'Std Product Code', width: 135, description: 'Std Product Code' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('productimportpreview', productImportPreviewColumns);


    // ECPProduct master
    const ecpproductColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 200, description: 'Franchise' },
        { field: 'productCode', headerName: 'Product Code', width: 200, description: 'Product Code' },
        { field: 'isActive', headerName: 'Is Active', width: 180, description: 'Is Active' },
    ];

    columnMaps.set('ecpproduct', ecpproductColumns);


    // ecpproductimportpreview
    const ecpproductImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'productCode', headerName: 'Product Code', width: 100, description: 'Product Code' },
        { field: 'isActive', headerName: 'Is Active', width: 75, description: 'Is Active' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('ecpproductimportpreview', ecpproductImportPreviewColumns);


    // Account master
    const accountColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'accountCode', headerName: 'Account Code', width: 100, description: 'Account Code' },
        { field: 'accountName', headerName: 'Account Name', width: 200, description: 'Account Name' },
        { field: 'accountAlias', headerName: 'Account Alias', width: 100, description: 'Account Alias' },
        { field: 'accountGroup', headerName: 'Account Group', width: 110, description: 'Account Group' },
        { field: 'isActive', headerName: 'Active', width: 65, description: 'Is Active' },
        { field: 'accountCity', headerName: 'City', width: 70, description: 'Account City' },
        { field: 'accountState', headerName: 'State', width: 80, description: 'Account State' },
        { field: 'accountRegion', headerName: 'Region', width: 65, description: 'Account Region' },
        { field: 'accountPrimaryEmail', headerName: 'Primary Email Id', width: 115, description: 'Account Primary Email' },
        { field: 'accountAlternateEmail', headerName: 'Alternate Email Id', width: 120, description: 'Account Alternative Email' },
        { field: 'accountContactNo', headerName: 'Contact No', width: 90, description: 'Account Contact No' },
        { field: 'accountAlternateContactNo', headerName: 'Alternate Contact No', width: 120, description: 'Account Alternate Contact No' },
        { field: 'accountContactPerson', headerName: 'Contact Person', width: 110, description: 'Account Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 150, description: 'Account Alternate Contact Person' },
        { field: 'accountType', headerName: 'Account Type', width: 100, description: 'Account Type' },
        { field: 'accountClassification', headerName: 'Account Classification', width: 150, description: 'Account Classification' },
        { field: 'accountSegmentation', headerName: 'Account Segmentation', width: 150, description: 'Account Segmentation' },
        { field: 'accountCityTier', headerName: 'Account City Tier', width: 120, description: 'Account City Tier' },
        { field: 'accountGSTIN', headerName: 'Account GSTIN', width: 110, description: 'Account GSTIN' },
        { field: 'accountPAN', headerName: 'Account PAN', width: 95, description: 'Account PAN' },
        { field: 'accountCategory', headerName: 'Account Category', width: 125, description: 'Account PAN' },
        { field: 'orgSegment', headerName: 'OrgSegment', width: 100, description: 'OrgSegment' },
        { field: 'accountSCGCode', headerName: 'Account SCG Code', width: 150, description: 'Account SCG Code' },
        { field: 'accountRegionalCode', headerName: 'Account Regional Code', width: 150, description: 'Account Regional Code' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('account', accountColumns);

    // AccpuntImportPreview

    const accountImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 200, description: 'Error message' },
        { field: 'accountCode', headerName: 'Account Code', width: 100, description: 'Account Code' },
        { field: 'accountName', headerName: 'Account Name', width: 200, description: 'Account Name' },
        { field: 'accountAlias', headerName: 'Account Alias', width: 100, description: 'Account Alias' },
        { field: 'accountGroup', headerName: 'Account Group', width: 110, description: 'Account Group' },
        { field: 'isActive', headerName: 'Is Active', width: 75, description: 'Is Active' },
        { field: 'accountCity', headerName: 'City', width: 70, description: 'Account City' },
        { field: 'accountState', headerName: 'State', width: 80, description: 'Account State' },
        { field: 'accountRegion', headerName: 'Region', width: 65, description: 'Account Region' },
        { field: 'accountPrimaryEmail', headerName: 'Primary Email Id', width: 115, description: 'Account Primary Email' },
        { field: 'accountAlternateEmail', headerName: 'Alternate Email Id', width: 120, description: 'Account Alternative Email' },
        { field: 'accountContactNo', headerName: 'Contact No', width: 90, description: 'Account Contact No' },
        { field: 'accountAlternateContactNo', headerName: 'Alternate Contact No', width: 120, description: 'Account Alternate Contact No' },
        { field: 'accountContactPerson', headerName: 'Contact Person', width: 110, description: 'Account Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 150, description: 'Account Alternate Contact Person' },
        { field: 'accountType', headerName: 'Account Type', width: 100, description: 'Account Type' },
        { field: 'accountClassification', headerName: 'Account Classification', width: 150, description: 'Account Classification' },
        { field: 'accountSegmentation', headerName: 'Account Segmentation', width: 150, description: 'Account Segmentation' },
        { field: 'accountCityTier', headerName: 'Account City Tier', width: 120, description: 'Account City Tier' },
        { field: 'accountGSTIN', headerName: 'Account GSTIN', width: 110, description: 'Account GSTIN' },
        { field: 'accountPAN', headerName: 'Account PAN', width: 95, description: 'Account PAN' },
        { field: 'accountCategory', headerName: 'Account Category', width: 125, description: 'Account PAN' },
        { field: 'orgSegment', headerName: 'OrgSegment', width: 100, description: 'OrgSegment' },
        { field: 'accountSCGCode', headerName: 'Account SCG Code', width: 150, description: 'Account SCG Code' },
        { field: 'accountRegionalCode', headerName: 'Account Regional Code', width: 150, description: 'Account Regional Code' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('accountimportpreview', accountImportPreviewColumns);

    // Area Tree
    const areatreeColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'country', headerName: 'Country', width: 150, description: 'Country' },
        { field: 'region', headerName: 'Region', width: 150, description: 'Region' },
        { field: 'state', headerName: 'State', width: 150, description: 'State' },
        { field: 'city', headerName: 'City', width: 150, description: 'City' },
    ];

    columnMaps.set('areatree', areatreeColumns);

    //   areatreeColumns Import Preview

    const areatreeImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'country', headerName: 'Country', width: 70, description: 'Country' },
        { field: 'region', headerName: 'Region', width: 70, description: 'Region' },
        { field: 'state', headerName: 'State', width: 70, description: 'State' },
        { field: 'city', headerName: 'City', width: 70, description: 'City' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('areatreeimportpreview', areatreeImportPreviewColumns);

    // Sales Hierarchy
    // const saleshierarchyColumns = [
    //  { field: 'id', headerName: 'ID', width: 0, hide: true },
    //  { field: 'wwid', headerName: 'WWID', width: 150, description: 'WWID' },
    //  { field: 'executiveName', headerName: 'Executive Name', width: 200, description: 'Executive Name' },
    //  { field: 'level', headerName: 'Level', width: 100, description: 'Level' },
    //    { field: 'reportingTo', headerName: 'Reporting To', width: 150, description: 'Reporting To' },
    //    { field: 'reportingFromDate', headerName: 'Reporting From Date', width: 150, description: 'Reporting From Date', valueFormatter: (params) => newFDate(params.value) },
    //    { field: 'reportingToDate', headerName: 'Reporting To Date', width: 150, description: 'Reporting To Date', valueFormatter: (params) => newFDate(params.value) },
    //  { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 150, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },

    // ];

    //  columnMaps.set('saleshierarchy', saleshierarchyColumns);

    //  //   saleshierarchyImportPreviewColumns
    //  const saleshierarchyImportPreviewColumns = [
    //      { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
    //      {
    //          field: 'recordType', headerName: 'Record Type', width: 100,
    //          description: 'Record Type',
    //          renderCell: (cellValues) => {
    //              console.log(cellValues);
    //              return GetValidatedComponent(cellValues);
    //          }
    //      },
    //      { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },

    //      { field: 'id', headerName: 'ID', width: 0, hide: true },
    //      { field: 'wwid', headerName: 'WWID', width: 150, description: 'WWID' },
    //      { field: 'executiveName', headerName: 'Executive Name', width: 200, description: 'Executive Name' },
    //      { field: 'level', headerName: 'Level', width: 100, description: 'Level' },
    //      { field: 'reportingTo', headerName: 'Reporting To', width: 150, description: 'Reporting To' },
    //      { field: 'reportingFromDate', headerName: 'Reporting From Date', width: 150, description: 'Reporting From Date', valueFormatter: (params) => newFDate(params.value) },
    //      { field: 'reportingToDate', headerName: 'Reporting To Date', width: 150, description: 'Reporting To Date', valueFormatter: (params) => newFDate(params.value) },
    //      { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 150, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    //  ];

    //  columnMaps.set('saleshierarchyimportpreview', saleshierarchyImportPreviewColumns);

    // Sales Hierarchy

    const saleshierarchyColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 150, description: 'Frenchise' },
        { field: 'wwId', headerName: 'WWID', width: 150, description: 'WWID' },
        { field: 'fsName', headerName: 'Field Staff Name', width: 200, description: 'Fs Name' },
        { field: 'suwwId', headerName: 'SuperWiser WWID', width: 200, description: 'SuWWID' },
        { field: 'suName', headerName: 'SuperWiser Name', width: 200, description: 'SuName' },
        { field: 'rsmwwId', headerName: 'RSM WWID', width: 150, description: 'RSM WWID' },
        { field: 'rsmName', headerName: 'RSM Name', width: 150, description: 'RSM Name' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 150, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];
    columnMaps.set('saleshierarchy', saleshierarchyColumns);

    //   saleshierarchyImportPreviewColumns
    const saleshierarchyImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 150, description: 'Frenchise' },
        { field: 'wwId', headerName: 'WWID', width: 150, description: 'WWID' },
        { field: 'fsName', headerName: 'Field Staff Name', width: 200, description: 'Fs Name' },
        { field: 'suwwId', headerName: 'SuperWiser WWID', width: 200, description: 'SuWWID' },
        { field: 'suName', headerName: 'SuperWiser Name', width: 200, description: 'SuName' },
        { field: 'rsmwwId', headerName: 'RSM WWID', width: 150, description: 'RSM WWID' },
        { field: 'rsmName', headerName: 'RSM Name', width: 150, description: 'RSM Name' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 150, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('saleshierarchyimportpreview', saleshierarchyImportPreviewColumns);

    // Surgeon Master
    const surgeonsColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 105, description: 'Surgeon Code' },
        { field: 'surgeonName', headerName: 'Surgeon Name', width: 200, description: 'Surgeon Name' },
        { field: 'surgeonCity', headerName: 'City', width: 70, description: 'Surgeon City' },
        { field: 'surgeonState', headerName: 'State', width: 70, description: 'Surgeon State' },
        { field: 'surgeonRegion', headerName: 'Region', width: 70, description: 'Surgeon Region' },
        { field: 'surgeonContactType', headerName: 'Contact Type', width: 100, description: 'Surgeon Contact Type' },
        { field: 'surgeonSubContactType', headerName: 'Sub Contact Type', width: 120, description: 'Surgeon Sub Contact Type' },
        { field: 'surgeonPrimaryContactNumber', headerName: 'Primary Contact No', width: 130, description: 'Surgeon Primary Contact No' },
        { field: 'surgeonAlternateContactNumber', headerName: 'Alternate Contact No', width: 140, description: 'Surgeon Alternate Contact No' },
        { field: 'surgeonPrimaryEmailID', headerName: 'Primary Email Id', width: 120, description: 'Surgeon Primary Email ID' },
        { field: 'surgeonAlternateEmailID', headerName: 'Alternate Email Id', width: 120, description: 'Surgeon Alternative Email ID' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
    ];

    columnMaps.set('surgeon', surgeonsColumns);

    // SurgeonImportPreviewColumns

    const surgeonImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 105, description: 'Surgeon Code' },
        { field: 'surgeonName', headerName: 'Surgeon Name', width: 200, description: 'Surgeon Name' },
        { field: 'surgeonCity', headerName: 'City', width: 70, description: 'Surgeon City' },
        { field: 'surgeonState', headerName: 'State', width: 70, description: 'Surgeon State' },
        { field: 'surgeonRegion', headerName: 'Region', width: 70, description: 'Surgeon Region' },
        { field: 'surgeonContactType', headerName: 'Contact Type', width: 100, description: 'Surgeon Contact Type' },
        { field: 'surgeonSubContactType', headerName: 'Sub Contact Type', width: 120, description: 'Surgeon Sub Contact Type' },
        { field: 'surgeonPrimaryContactNumber', headerName: 'Primary Contact No', width: 130, description: 'Surgeon Primary Contact No' },
        { field: 'surgeonAlternateContactNumber', headerName: 'Alternate Contact No', width: 140, description: 'Surgeon Alternate Contact No' },
        { field: 'surgeonPrimaryEmailID', headerName: 'Primary Email Id', width: 120, description: 'Surgeon Primary Email ID' },
        { field: 'surgeonAlternateEmailID', headerName: 'Alternate Email Id', width: 120, description: 'Surgeon Alternative Email ID' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('surgeonimportpreview', surgeonImportPreviewColumns);

    // Net Realization Rate 

    const netrealizationrateColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'productCode', headerName: 'Product Code', width: 150, description: 'Product Code' },
        { field: 'nrrType', headerName: 'NRR Type', width: 150, description: 'NRR Type' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'accountCode', headerName: 'Account Code', width: 150, description: 'Account Code' },
        { field: 'nrr', headerName: 'NRR', width: 100, description: 'NRR' },
        { field: 'fromDate', headerName: 'From Date', width: 150, description: 'From Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 150, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('nrr', netrealizationrateColumns);

    // NRRImport preview
    const nrrImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'productCode', headerName: 'Product Code', width: 150, description: 'Product Code' },
        { field: 'nrrType', headerName: 'NRR Type', width: 150, description: 'NRR Type' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'accountCode', headerName: 'Account Code', width: 150, description: 'Account Code' },
        { field: 'nrr', headerName: 'NRR', width: 100, description: 'NRR' },
        { field: 'fromDate', headerName: 'From Date', width: 150, description: 'From Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 150, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('nrrimportpreview', nrrImportPreviewColumns);

    // Employee 

    const employeeColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'wwId', headerName: 'WWID', width: 65, description: 'WWID' },
        { field: 'firstName', headerName: 'First Name', width: 100, description: 'First Name' },
        { field: 'lastName', headerName: 'Last Name', width: 100, description: 'Last Name' },
        { field: 'emailId', headerName: 'Email', width: 100, description: 'Email' },
        { field: 'contactNo', headerName: 'Contact No', width: 100, description: 'Contact No' },
        { field: 'empLevel', headerName: 'Level', width: 60, description: 'Level' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('empmaster', employeeColumns);

    // Employee preview
    const employeePreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'wwId', headerName: 'WWID', width: 65, description: 'WWID' },
        { field: 'firstName', headerName: 'First Name', width: 100, description: 'First Name' },
        { field: 'lastName', headerName: 'Last Name', width: 100, description: 'Last Name' },
        { field: 'emailId', headerName: 'Email', width: 100, description: 'Email' },
        { field: 'contactNo', headerName: 'Contact No', width: 100, description: 'Contact No' },
        { field: 'empLevel', headerName: 'Level', width: 60, description: 'Level' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('empmasterimportpreview', employeePreviewColumns);

    // Territory

    const territoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'code', headerName: 'Code', width: 150, description: 'Code' },
        { field: 'description', headerName: 'Description', width: 150, description: 'Description' },
        { field: 'isActive', headerName: 'IsActive', width: 100, description: 'IsActive' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('territory', territoryColumns);

    // Territory preview
    const territoryPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'code', headerName: 'Code', width: 110, description: 'Code' },
        { field: 'description', headerName: 'Description', width: 90, description: 'Description' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('territoryimportpreview', territoryPreviewColumns);

    // Emp Territory

    const empterritoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'SubFranchise', width: 100, description: 'SubFranchise' },
        { field: 'specialist', headerName: 'Specialist', width: 90, description: 'Specialist' },
        { field: 'wwId', headerName: 'WWID', width: 65, description: 'WWID' },
        { field: 'empLevel', headerName: 'EmpLevel', width: 80, description: 'EmpLevel' },
        { field: 'territory', headerName: 'Territory', width: 100, description: 'Territory' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('empterritory', empterritoryColumns);

    // Emp Territory preview
    const empterritoryPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'SubFranchise', width: 100, description: 'SubFranchise' },
        { field: 'specialist', headerName: 'Specialist', width: 90, description: 'Specialist' },
        { field: 'wwId', headerName: 'WWID', width: 65, description: 'WWID' },
        { field: 'empLevel', headerName: 'EmpLevel', width: 80, description: 'EmpLevel' },
        { field: 'territory', headerName: 'Territory', width: 100, description: 'Territory' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('empterritoryimportpreview', empterritoryPreviewColumns);

    // Emp Region

    const empregionColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'wwid', headerName: 'WWID', width: 60, description: 'WWID' },
        { field: 'region', headerName: 'Region', width: 80, description: 'Region' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('empregion', empregionColumns);

    // Emp Region preview
    const empregionPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'wwid', headerName: 'WWID', width: 60, description: 'WWID' },
        { field: 'region', headerName: 'Region', width: 80, description: 'Region' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('empregionimportpreview', empregionPreviewColumns);

    // Account Territory

    const accountTerritoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'SubFranchise', width: 100, description: 'SubFranchise' },
        { field: 'accountCode', headerName: 'Account Code', width: 100, description: 'Account Code' },
        { field: 'accountName', headerName: 'Account Name', width: 200, description: 'Account Name' },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 110, description: 'Surgeon Code' },
        { field: 'distributorCode', headerName: 'SAP Customer Code', width: 140, description: 'SAP Customer Code' },
        { field: 'fsTerritory', headerName: 'FS Territory', width: 120, description: 'FS Territory' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'FromDate', width: 110, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'ToDate', width: 110, description: 'ToDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('accountterritory', accountTerritoryColumns);

    // Account Territory preview
    const accountterritoryPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'SubFranchise', width: 100, description: 'SubFranchise' },
        { field: 'accountCode', headerName: 'Account Code', width: 100, description: 'Account Code' },
        { field: 'accountName', headerName: 'Account Name', width: 200, description: 'Account Name' },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 110, description: 'Surgeon Code' },
        { field: 'distributorCode', headerName: 'SAP Customer Code', width: 140, description: 'SAP Customer Code' },
        { field: 'fsTerritory', headerName: 'FS Territory', width: 120, description: 'FS Territory' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'FromDate', width: 110, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'ToDate', width: 110, description: 'ToDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('accountterritoryimportpreview', accountterritoryPreviewColumns);

    // Distributor Territory

    const distributorTerritoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'Sub Franchise', width: 110, description: 'Sub Franchise' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 120, description: 'Distributor Code' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 200, description: 'Distributor Name' },
        { field: 'fsTerritory', headerName: 'FS Territory', width: 100, description: 'FS Territory' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'FromDate', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'ToDate', width: 100, description: 'ToDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('distributorterritory', distributorTerritoryColumns);

    // Distributor Territory preview
    const distributorterritoryPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'subFranchise', headerName: 'Sub Franchise', width: 110, description: 'Sub Franchise' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 120, description: 'Distributor Code' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 200, description: 'Distributor Name' },
        { field: 'fsTerritory', headerName: 'FS Territory', width: 100, description: 'FS Territory' },
        { field: 'isActive', headerName: 'IsActive', width: 70, description: 'IsActive' },
        { field: 'fromDate', headerName: 'FromDate', width: 100, description: 'FromDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'ToDate', width: 100, description: 'ToDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('distributorterritoryimportpreview', distributorterritoryPreviewColumns);

    // Territory Hierarchy 

    const territoryhierarchyColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'region', headerName: 'Territory Region', width: 70, description: 'Territory Region' },
        { field: 'fsTerritory', headerName: 'FS Territory', width: 100, description: 'FSTerritory' },
        { field: 'suTerritory', headerName: 'SU Territory', width: 100, description: 'SUTerritory' },
        { field: 'rsmTerritory', headerName: 'RSM Territory', width: 100, description: 'RSMTerritory' },
        { field: 'nsmTerritory', headerName: 'NSM Territory', width: 110, description: 'NSMTerritory' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('territoryhierarchy', territoryhierarchyColumns);

    // Territory Hierarchy  preview
    const territoryhierarchyPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'region', headerName: 'Territory Region', width: 70, description: 'Territory Region' },
        { field: 'fsTerritory', headerName: 'FS Territory', width: 100, description: 'FSTerritory' },
        { field: 'suTerritory', headerName: 'SU Territory', width: 100, description: 'SUTerritory' },
        { field: 'rsmTerritory', headerName: 'RSM Territory', width: 100, description: 'RSMTerritory' },
        { field: 'nsmTerritory', headerName: 'NSM Territory', width: 110, description: 'NSMTerritory' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('territoryhierarchyimportpreview', territoryhierarchyPreviewColumns);

    // OrgGroupDefination 
    const orggroupdefinationColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'vertical', headerName: 'Vertical', width: 70, description: 'Group' },
        { field: 'groupDisplayName', headerName: 'Group Display Name', width: 140, description: 'GroupDisplayName' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Frenchise' },
        { field: 'subFranchise', headerName: 'Sub Franchise', width: 110, description: 'SubFrenchise' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('orggroupdefinition', orggroupdefinationColumns);

    // OrgGroupDefination  preview
    const orgGroupDefinitionPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'vertical', headerName: 'Vertical', width: 70, description: 'Group' },
        { field: 'groupDisplayName', headerName: 'Group Display Name', width: 140, description: 'GroupDisplayName' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Frenchise' },
        { field: 'subFranchise', headerName: 'Sub Franchise', width: 110, description: 'SubFrenchise' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('orggroupdefinitionimportpreview', orgGroupDefinitionPreviewColumns);


    // StandardPrice 
    const standardpriceColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 180, description: 'Franchise' },
        { field: 'productCode', headerName: 'Product Code', width: 180, description: 'Product Code' },
        { field: 'rate', headerName: 'Rate', width: 150, description: 'Rate' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];
    columnMaps.set('standardpricemaster', standardpriceColumns);

    // StandardPrice  preview
    const standardPricePreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'franchise', headerName: 'Franchise', width: 80, description: 'Franchise' },
        { field: 'productCode', headerName: 'Product Code', width: 100, description: 'Product Code' },
        { field: 'rate', headerName: 'Rate', width: 100, description: 'Rate' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('standardpricemasterimportpreview', standardPricePreviewColumns);


    // DistrubutorBillingSoftware
    const distributorbillingsoftwareColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'DistributorCode', width: 110, description: 'DistributorCode' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 200, description: 'Distributor Name' },
        { field: 'software', headerName: 'Software', width: 200, description: 'Software' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];
    columnMaps.set('distributorbillingsoftware', distributorbillingsoftwareColumns);

    // DistrubutorBillingSoftware  preview
    const distributorBillingSoftwarePreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'distributorCode', headerName: 'DistributorCode', width: 110, description: 'DistributorCode' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 200, description: 'Distributor Name' },
        { field: 'software', headerName: 'Software', width: 200, description: 'Software' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];
    columnMaps.set('distributorbillingsoftwareimportpreview', distributorBillingSoftwarePreviewColumns);

    // DealerAgreementExpiry 

    const dealeragreementexpiryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 120, description: 'DistributorCode' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 200, description: 'DistributorName' },
        { field: 'contractExpiryDate', headerName: 'Contract Expiry Date', width: 140, description: 'ContractExpiryDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('dealeragreementexpiry', dealeragreementexpiryColumns);

    // DealerAgreementExpiry  preview
    const dealerAgreementExpiryPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 120, description: 'DistributorCode' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 100, description: 'DistributorName' },
        { field: 'contractExpiryDate', headerName: 'Contract Expiry Date', width: 150, description: 'ContractExpiryDate', valueFormatter: (params) => newFDate(params.value) },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];
    columnMaps.set('dealeragreementexpiryimportpreview', dealerAgreementExpiryPreviewColumns);

    // DealerRating
    const dealerratingColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'drQuarter', headerName: 'Quarter', width: 70, description: 'Quarter' },
        { field: 'drYear', headerName: 'Year', width: 50, description: 'Year', align: 'right' },
        { field: 'distributorCode', headerName: 'Dealer Code', width: 95, description: 'DealerCode' },
        { field: 'distributorName', headerName: 'Dealer Name', width: 200, description: 'DealerName' },
        { field: 'dso', headerName: 'DSO', width: 60, description: 'DSO', align: 'right' },
        { field: 'avgDSOScore', headerName: 'Avg DSO Code', width: 110, description: 'AvgDSOCode', align: 'right' },
        { field: 'dsrSkewness', headerName: 'DSR Skewness', width: 110, description: 'DSRSkewness', align: 'right' },
        { field: 'avgDSRScore', headerName: 'Avg. DSR score', width: 110, description: 'AvgDSRScore', align: 'right' },
        { field: 'retailGrowth', headerName: 'Retail Growth', width: 100, description: 'RetailGrowth', align: 'right' },
        { field: 'avgRGScore', headerName: 'Avg RG Score', width: 100, description: 'AvgRGScore', align: 'right' },
        { field: 'avgZylemScore', headerName: 'Avg Zylem Score', width: 120, description: 'AvgZylemScore', align: 'right' },
        { field: 'avgTotalScore', headerName: 'Avg Total Score', width: 110, description: 'AvgTotalScore1', align: 'right' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) }
    ];

    columnMaps.set('dealerrating', dealerratingColumns);

    // DealerRating  preview
    const dealerRatingPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'drQuarter', headerName: 'Quarter', width: 70, description: 'Quarter' },
        { field: 'drYear', headerName: 'Year', width: 50, description: 'Year', align: 'right' },
        { field: 'distributorCode', headerName: 'Dealer Code', width: 95, description: 'DealerCode' },
        { field: 'distributorName', headerName: 'Dealer Name', width: 200, description: 'DealerName' },
        { field: 'dso', headerName: 'DSO', width: 60, description: 'DSO', align: 'right' },
        { field: 'avgDSOScore', headerName: 'Avg DSO Code', width: 110, description: 'AvgDSOCode', align: 'right' },
        { field: 'dsrSkewness', headerName: 'DSR Skewness', width: 110, description: 'DSRSkewness', align: 'right' },
        { field: 'avgDSRScore', headerName: 'Avg. DSR score', width: 110, description: 'AvgDSRScore', align: 'right' },
        { field: 'retailGrowth', headerName: 'Retail Growth', width: 100, description: 'RetailGrowth', align: 'right' },
        { field: 'avgRGScore', headerName: 'Avg RG Score', width: 100, description: 'AvgRGScore', align: 'right' },
        { field: 'avgZylemScore', headerName: 'Avg Zylem Score', width: 120, description: 'AvgZylemScore', align: 'right' },
        { field: 'avgTotalScore', headerName: 'Avg Total Score', width: 110, description: 'AvgTotalScore1', align: 'right' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) }
    ];
    columnMaps.set('dealerratingimportpreview', dealerRatingPreviewColumns);

    // User
    const userColumns = [
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 20,
            renderCell: (cellValues) => (
                <UserMasterMoreMenu cellValues={cellValues} />
            )
        },
        { field: 'userName', headerName: 'User Email ID', width: 150, description: 'User Email ID' },
        { field: 'firstName', headerName: 'First Name', width: 150, description: 'First Name' },
        { field: 'lastName', headerName: 'Last Name', width: 150, description: 'Last Name' },
        { field: 'userStatus', headerName: 'User Status', width: 150, description: 'User Status' },
        { field: 'userType', headerName: 'User Type', width: 150, description: 'User Type' },
        { field: 'roleName', headerName: 'Role', width: 200, description: 'Role' },
        { field: 'userprimaryEmail', headerName: 'User Primary Email', width: 250, description: 'User Primary Email' },
        { field: 'city', headerName: 'City', width: 200, description: 'City' },
        { field: 'state', headerName: 'State', width: 200, description: 'State' },
        { field: 'country', headerName: 'Country', width: 200, description: 'Country' },
        { field: 'countryisocode', headerName: 'Country ISO Code', width: 200, description: 'Country ISO Code' },
        { field: 'line1', headerName: 'Line 1', width: 200, description: 'Line 1' },
        { field: 'line2', headerName: 'Line 2', width: 200, description: 'Line 2' },
        { field: 'postalcode', headerName: 'Postal Code', width: 200, description: 'Postal Code' },
        { field: 'regionisocode', headerName: 'Region Iso Code', width: 200, description: 'Region Iso Code' },

    ];

    columnMaps.set('usermaster', userColumns);

    // user Import preview
    const userImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'userName', headerName: 'Username', width: 160, description: 'Username' },
        { field: 'firstName', headerName: 'First Name', width: 160, description: 'First Name' },
        { field: 'lastName', headerName: 'Last Name', width: 160, description: 'Last Name' },
        { field: 'userRole', headerName: 'User Role', width: 160, description: 'User Role' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 180, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('usermasterimportpreview', userImportPreviewColumns);

    // User access rights
    const useraccessrightsColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'userRole', headerName: 'User Role', width: 230, description: 'User Role' },
        { field: 'module', headerName: 'Module', width: 230, description: 'Module' },
        { field: 'url', headerName: 'URL', width: 280, description: 'URL' },
    ];

    columnMaps.set('useraccessrights', useraccessrightsColumns);

    // user access rights Import preview
    const useraccessrightsImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'userRole', headerName: 'User Role', width: 230, description: 'User Role' },
        { field: 'module', headerName: 'Module', width: 230, description: 'Module' },
        { field: 'url', headerName: 'URL', width: 280, description: 'URL' },
    ];

    columnMaps.set('useraccessrightsimportpreview', useraccessrightsImportPreviewColumns);

    // Product Variant 
    const productvariantColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'variantProductCode', headerName: 'Variant Product Code', width: 200, description: 'Variant Product Code' },
        { field: 'productCode', headerName: 'Product Code', width: 180, description: 'Product Code' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 150, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('productvariant', productvariantColumns);

    // Product Variant Import Preview
    const productvariantImportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'variantProductCode', headerName: 'Variant Product Code', width: 180, description: 'Variant Product Code' },
        { field: 'productCode', headerName: 'Product Code', width: 180, description: 'Product Code' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 150, description: 'EffectiveFromDate', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('productvariantimportpreview', productvariantImportPreviewColumns);

    // Field Staff allocation 

    const undefinedColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'accountcode', headerName: 'Define  in Master Data def', width: 300, description: 'Product Code' },
    ];

    columnMaps.set('fieldstaffallocation', undefinedColumns);
    columnMaps.set('customersalesteam', undefinedColumns);


    // Allied Masters
    const alliedmastersColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'code', headerName: 'Code', width: 150, description: 'Code' },
        { field: 'description', headerName: 'Description', width: 300, description: 'Description' },
    ];

    columnMaps.set('distributorgroup', alliedmastersColumns);
    columnMaps.set('uom', alliedmastersColumns);
    columnMaps.set('franchise', alliedmastersColumns);
    columnMaps.set('subfranchise', alliedmastersColumns);
    columnMaps.set('productgroup', alliedmastersColumns);
    columnMaps.set('productcategory', alliedmastersColumns);
    columnMaps.set('productbrand', alliedmastersColumns);
    columnMaps.set('productline', alliedmastersColumns);
    columnMaps.set('accountgroup', alliedmastersColumns);
    columnMaps.set('accounttype', alliedmastersColumns);
    columnMaps.set('accountclassification', alliedmastersColumns);
    columnMaps.set('accountsegmentation', alliedmastersColumns);
    columnMaps.set('accountcategory', alliedmastersColumns);
    columnMaps.set('surgeoncontacttype', alliedmastersColumns);
    columnMaps.set('surgeonsubcontacttype', alliedmastersColumns);
    columnMaps.set('citytier', alliedmastersColumns);
    // columnMaps.set('territory', alliedmastersColumns);
    columnMaps.set('emplevel', alliedmastersColumns);
    columnMaps.set('specialist', alliedmastersColumns);
    columnMaps.set('bravohierarchy', alliedmastersColumns);

    // Allied Masters
    const alliedmastersimportPreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // { field: 'recordType', headerName: '', width: 300, description: 'Record Type' },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 200, description: 'Error message' },
        { field: 'code', headerName: 'Code', width: 80, description: 'Code' },
        { field: 'description', headerName: 'Description', width: 200, description: 'Description' },
        { field: 'effectiveFromDate', headerName: 'Effective from date', width: 135, description: 'Effective from date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('distributorgroupimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('uomimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('franchiseimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('subfranchiseimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('productgroupimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('productcategoryimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('productbrandimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('productlineimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('accountgroupimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('accounttypeimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('accountclassificationimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('accountsegmentationimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('accountcategoryimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('surgeoncontacttypeimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('surgeonsubcontacttypeimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('citytierimportpreview', alliedmastersimportPreviewColumns);
    // columnMaps.set('territoryimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('emplevelimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('specialistimportpreview', alliedmastersimportPreviewColumns);
    columnMaps.set('bravohierarchyimportpreview', alliedmastersimportPreviewColumns);

    //    columnMaps.set('accountdivision', alliedmastersColumns);
    const helpcategoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'categoryName', headerName: 'Category Name', width: 150, description: 'Category Name' },
        { field: 'seqNo', headerName: 'Sequence Number', width: 150, description: 'Sequence Number', align: 'right' },
        { field: 'iconName', headerName: 'Icon', width: 150, description: 'Icon' },
        { field: 'description', headerName: 'Description', width: 200, description: 'Category Description' },
    ];

    columnMaps.set('helpcategory', helpcategoryColumns);

    const helptopicsColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'topicName', headerName: 'Topic Name', width: 250, description: 'Topic Name' },
        { field: 'categoryName', headerName: 'Category Name', width: 150, description: 'Category Name' },
        { field: 'categoryId', headerName: 'Category Id', width: 150, description: 'Category Id', hide: true },
        { field: 'subCategoryName', headerName: 'Sub-Category Name', width: 150, description: 'Sub-Category Name' },
        { field: 'subCategoryId', headerName: 'Sub-Category Id', width: 150, description: 'Sub-Category Id', hide: true },
        { field: 'menuName', headerName: 'Menu Name', width: 150, description: 'Menu Name', hide: true },
        { field: 'menuId', headerName: 'Menu Id', width: 150, description: 'Menu Id', hide: true },
        { field: 'description', headerName: 'Description', width: 250, description: 'Description' },
        { field: 'topicTypeName', headerName: 'Topic Type', width: 120, description: 'Topic Type Name' },
        { field: 'topicType', headerName: 'Topic Type Id', width: 120, description: 'Topic Type Id', hide: true },
        { field: 'attachment', headerName: 'Attachment', width: 200, description: 'Attachment' },
        { field: 'ownerName', headerName: 'Owner Name', width: 120, description: 'Owner Name' },
        // { field: 'ownerFranchise', headerName: 'Franchise Name', width: 120, description: 'Franchise Name' },
        { field: 'ownerFranchise', headerName: 'Franchise Name', width: 120, description: 'Franchise Name', valueFormatter: (params) => params.value === null || params.value.toLowerCase() === 'Null'.toLowerCase() ? '' : params.value },
        { field: 'tags', headerName: 'Tags', width: 200, description: 'Tags' },
        { field: 'attributeName', headerName: 'Attribute Name', width: 150, description: 'Attribute Name', hide: true },
        { field: 'attributeValue', headerName: 'Attribute Value', width: 150, description: 'Attribute Value', hide: true },
        { field: 'publishedDate', headerName: 'Published Date', width: 150, description: 'Published Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'expiryDate', headerName: 'Expiry Date', width: 150, description: 'Expiry Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'statusName', headerName: 'Status', width: 100, description: 'Post Status' },
        { field: 'content', headerName: 'Content', width: 140, description: 'Post Status', hide: true },
    ];

    columnMaps.set('helptopics', helptopicsColumns);

    const subcategoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'subCategoryName', headerName: 'Sub-Category Name', width: 250, description: 'sub-Category Name' },
        { field: 'categoryName', headerName: 'Category Name', width: 150, description: 'Category Name' },
        { field: 'categoryId', headerName: 'Category Id', width: 150, description: 'Category Id', hide: true },
        // { field: 'menuName', headerName: 'Menu Name', width: 150, description: 'Menu Name' },
        { field: 'menuId', headerName: 'Menu Name', width: 150, description: 'Menu Name', hide: true },
        { field: 'description', headerName: 'Description', width: 250, description: 'Description' },
        { field: 'tags', headerName: 'Tags', width: 120, description: 'Tags' },
    ];

    columnMaps.set('subcategory', subcategoryColumns);

    const helpmenusColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'category', headerName: 'Category', width: 200, description: 'Category Name' },
        { field: 'menuName', headerName: 'Menu Name', width: 150, description: 'Menu Name' },
        { field: 'seqNo', headerName: 'Sequence Number', width: 150, description: 'Sequence Number', align: 'right' },
        { field: 'description', headerName: 'Description', width: 350, description: 'Description' },
    ];

    columnMaps.set('helpmenus', helpmenusColumns);

    const helpmenusColumnsimportpreview = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // { field: 'recordType', headerName: '', width: 300, description: 'Record Type' },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 300, description: 'Error message' },
        { field: 'menuName', headerName: 'Menu Name', width: 150, description: 'Menu Name' },
        { field: 'seqNo', headerName: 'Sequence Number', width: 150, description: 'Sequence Number', align: 'right' },
        { field: 'description', headerName: 'Description', width: 350, description: 'Description' },
        { field: 'category', headerName: 'Category', width: 200, description: 'Category Name' },

    ];

    columnMaps.set('helpmenusimportpreview', helpmenusColumnsimportpreview);

    const helpcategorypreviewColumns = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // { field: 'recordType', headerName: '', width: 300, description: 'Record Type' },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 300, description: 'Error message' },

        { field: 'categoryName', headerName: 'Category Name', width: 150, description: 'Category Name' },
        { field: 'seqNo', headerName: 'Sequence Number', width: 150, description: 'Sequence Number', align: 'right' },

        { field: 'description', headerName: 'Description', width: 350, description: 'Category Description' },

    ];
    columnMaps.set('helpcategoryimportpreview', helpcategorypreviewColumns);

    const helptagsColumnsimportpreview = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        // { field: 'recordType', headerName: '', width: 300, description: 'Record Type' },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 300, description: 'Error message' },
        { field: 'code', headerName: 'Code', width: 150, description: 'Code' },
        { field: 'description', headerName: 'Description', width: 350, description: 'Description' },

    ];

    columnMaps.set('tagsimportpreview', helptagsColumnsimportpreview);

    const accountallocationcloumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'month', headerName: 'Month', width: 150, description: 'Month' },
        { field: 'file', headerName: 'File', width: 150, description: 'File' },
        { field: 'uploaddate', headerName: 'Upload Date', width: 150, description: 'Upload Date' },
        { field: 'status', headerName: 'Status', width: 200, description: 'Status' },

    ];

    columnMaps.set('accountverification', accountallocationcloumns);

    const accountallocationcloumnspreview = [
        { field: 'rowNum', headerName: 'ID', width: 0, hide: true },
        { field: 'file', headerName: 'File', width: 150, description: 'File' },
        { field: 'message', headerName: 'Message', width: 150, description: 'Message' },
        { field: 'description', headerName: 'Description', width: 150, description: 'Description' },
        { field: 'error', headerName: 'Error', width: 200, description: 'Error' },

    ];

    columnMaps.set('accountverificationimportpreview', accountallocationcloumnspreview);



    columnMaps.set('transactionallocationimportpreview', accountallocationcloumnspreview);

    const transactionallocationcolumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'month', headerName: 'Month', width: 150, description: 'Month' },
        { field: 'split', headerName: 'Split', width: 150, description: 'Split', align: 'right' },
        { field: 'franchise', headerName: 'Franchise', width: 0, hide: true },
        { field: 'download', headerName: 'Download', width: 200, description: 'Download' },
        { field: 'lastsplitdocno', headerName: 'LastSplitDocNo', width: 200, description: 'LastSplitDocNo' },
        { field: 'lastSplitDate', headerName: 'LastSplitDate', width: 200, description: 'LastSplitDate' },
    ];

    columnMaps.set('transactionallocation', transactionallocationcolumns);

    const tagColumns = [
        // { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'code', headerName: 'Code', width: 120, description: 'Code' },
        { field: 'description', headerName: 'Description', width: 150, description: 'Description' },

    ];

    columnMaps.set('tags', tagColumns);

    // Customer master
    const customerColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'customerCode', headerName: 'Code', width: 60, description: 'Customer code' },
        { field: 'customerName', headerName: 'Name', width: 200, description: 'Customer Name' },
        { field: 'customerAlias', headerName: 'Alias', width: 60, description: 'Customer Alias' },
        { field: 'customerGroup', headerName: 'Group', width: 110, description: 'Customer Group' },
        { field: 'salesOrg', headerName: 'Sales Organization', width: 130, description: 'Sales Organization' },
        { field: 'isActive', headerName: 'Active', width: 65, description: 'Is Active' },
        { field: 'customerCity', headerName: 'City', width: 70, description: 'Customer City' },
        { field: 'customerState', headerName: 'State', width: 80, description: 'Customer State' },
        { field: 'customerRegion', headerName: 'Region', width: 65, description: 'Customer Region' },
        { field: 'customerPrimaryEmail', headerName: 'Primary Email', width: 120, description: 'Customer Primary Email' },
        { field: 'customerAlternateEmail', headerName: 'Alternate Email', width: 120, description: 'Customer Alternative Email' },
        { field: 'customerContactNo', headerName: 'Contact No', width: 90, description: 'Customer Contact No' },
        { field: 'customerAlternateContactNo', headerName: 'Alternate Contact No', width: 120, description: 'Customer Alternate Contact No' },
        { field: 'customerContactPerson', headerName: 'Contact Person', width: 110, description: 'Customer Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 130, description: 'Customer Alternate Contact Person' },
    ];

    columnMaps.set('customers', customerColumns);

    // customerimportpreview
    const customerImportPreviewColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'customerCode', headerName: 'Code', width: 60, description: 'Customer code' },
        { field: 'customerName', headerName: 'Name', width: 200, description: 'Customer Name' },
        { field: 'customerAlias', headerName: 'Alias', width: 60, description: 'Customer Alias' },
        { field: 'customerGroup', headerName: 'Group', width: 110, description: 'Customer Group' },
        { field: 'salesOrg', headerName: 'Sales Organization', width: 130, description: 'Sales Organization' },
        { field: 'isActive', headerName: 'Active', width: 65, description: 'Is Active' },
        { field: 'customerCity', headerName: 'City', width: 70, description: 'Customer City' },
        { field: 'customerState', headerName: 'State', width: 80, description: 'Customer State' },
        { field: 'customerRegion', headerName: 'Region', width: 65, description: 'Customer Region' },
        { field: 'customerPrimaryEmail', headerName: 'Primary Email', width: 120, description: 'Customer Primary Email' },
        { field: 'customerAlternateEmail', headerName: 'Alternate Email', width: 120, description: 'Customer Alternative Email' },
        { field: 'customerContactNo', headerName: 'Contact No', width: 90, description: 'Customer Contact No' },
        { field: 'customerAlternateContactNo', headerName: 'Alternate Contact No', width: 120, description: 'Customer Alternate Contact No' },
        { field: 'customerContactPerson', headerName: 'Contact Person', width: 110, description: 'Customer Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 130, description: 'Customer Alternate Contact Person' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('customersimportpreview', customerImportPreviewColumns);

    // Customer Account master
    const customerAccountColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'customerCode', headerName: 'Customer Code', width: 110, description: 'Customer code' },
        { field: 'jnJAccountCode', headerName: 'JnJ Account Code', width: 120, description: 'JnJ Account Code' },
        { field: 'accountName', headerName: 'Account Name', width: 200, description: 'Account Name' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'From Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'isActive', headerName: 'Active', width: 65, description: 'Is Active' },
    ];

    columnMaps.set('customeraccount', customerAccountColumns);

    // customerAccountimportpreview
    const customerAccountImportPreviewColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        // {
        //     field: 'recordType', headerName: 'Record Type', width: 100, description: 'Record Type',
        //     renderCell: (params) => GetValidatedComponent({ value: params.recordType })
        // },
        { field: 'errorMessage', headerName: 'Error message', width: 150, description: 'Error message' },
        { field: 'customerCode', headerName: 'Customer Code', width: 110, description: 'Customer code' },
        { field: 'jnJAccountCode', headerName: 'JnJ Account Code', width: 120, description: 'JnJ Account Code' },
        { field: 'accountName', headerName: 'Account Name', width: 200, description: 'Account Name' },
        { field: 'fromDate', headerName: 'From Date', width: 100, description: 'From Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'toDate', headerName: 'To Date', width: 100, description: 'To Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'isActive', headerName: 'Active', width: 65, description: 'Is Active' },
        { field: 'effectiveFromDate', headerName: 'Effective From Date', width: 135, description: 'Effective From Date', valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('customeraccountimportpreview', customerAccountImportPreviewColumns);

    return columnMaps.get(masterName);

}

export function GetPageTitle(masterName) {
    const pageTitleMaps = new Map();

    pageTitleMaps.set('distributor', "Distributor");
    pageTitleMaps.set('product', "Product");
    pageTitleMaps.set('ecpproduct', "ECP Product");
    pageTitleMaps.set('master', "Master");
    pageTitleMaps.set('netretailing', "Net Retailing");
    pageTitleMaps.set('masterlist', "Master List");
    pageTitleMaps.set('supervisorlist', "NetRetailing List");
    pageTitleMaps.set('account', "Account");
    pageTitleMaps.set('surgeon', "Surgeon");
    pageTitleMaps.set('surgeons', "Surgeon");
    pageTitleMaps.set('areatree', "Area Tree");
    pageTitleMaps.set('saleshierarchy', "Sales Hierarchy");
    pageTitleMaps.set('empmaster', "Employee");
    pageTitleMaps.set('empterritory', "Employee Territory");
    pageTitleMaps.set('accountterritory', "Territory Management");
    // pageTitleMaps.set('empregion', "Employee Region");
    pageTitleMaps.set('empregion', "Branch Secretary Region");
    // pageTitleMaps.set('accountterritory', "Account Territory");
    pageTitleMaps.set('distributorterritory', "Distributor Territory");
    pageTitleMaps.set('territoryhierarchy', "Territory Hierarchy");
    pageTitleMaps.set('orggroupdefinition', "Organization Group ");
    pageTitleMaps.set('dealeragreementexpiry', "Dealer Agreement");
    pageTitleMaps.set('standardpricemaster', "Standard Price");
    pageTitleMaps.set('dealerrating', "Dealer Rating");
    pageTitleMaps.set('distributorbillingsoftware', "Distributor Billing Software");
    pageTitleMaps.set('nrr', "NRR");
    pageTitleMaps.set('netrealizationrate', "NRR");
    pageTitleMaps.set('fieldstaffallocation', "Field Staff Allocation");
    pageTitleMaps.set('usermaster', "UserMaster");
    pageTitleMaps.set('user', "UserMaster");
    pageTitleMaps.set('useraccessrights', "User Access Rights");
    pageTitleMaps.set('distributorgroup', "Distributor Group");
    pageTitleMaps.set('uom', "UOM");
    pageTitleMaps.set('franchise', "Franchise");
    pageTitleMaps.set('subfranchise', "Sub Franchise");
    pageTitleMaps.set('productgroup', "Product Group");
    pageTitleMaps.set('productcategory', "Product Category");
    pageTitleMaps.set('productbrand', "Product Brand");
    pageTitleMaps.set('productline', "Product Line");
    pageTitleMaps.set('accountgroup', "Account Group");
    pageTitleMaps.set('accounttype', "Account Type");
    pageTitleMaps.set('accountclassification', "Account Classification");
    pageTitleMaps.set('accountsegmentation', "Account Segmentation");
    pageTitleMaps.set('accountcategory', "Account Category");
    pageTitleMaps.set('surgeoncontacttype', "Surgeon Contact Type");
    pageTitleMaps.set('surgeonsubcontacttype', "Surgeon Sub Contact Type");
    pageTitleMaps.set('citytier', "City Tier");
    pageTitleMaps.set('territory', "Territory");
    pageTitleMaps.set('emplevel', "Employee Level");
    pageTitleMaps.set('specialist', "Specialist");
    pageTitleMaps.set('datauploadtemplatemapping', "Data Upload Template Mapping ");
    pageTitleMaps.set('snstemplatemapping', "SNS Template Mapping");
    pageTitleMaps.set('alliedmaster', "Allied Master");
    pageTitleMaps.set('configuration', "Configuration");
    pageTitleMaps.set('masterlist', "Master List");
    pageTitleMaps.set('alliedmasterlist', "Allied Master List");
    pageTitleMaps.set('configurationlist', "Configuration List");
    pageTitleMaps.set('customersalesteam', "Customer SalesTeam");
    pageTitleMaps.set('productvariant', "Product Variant");
    pageTitleMaps.set('helpcategory', "Help Category");
    pageTitleMaps.set('helptopics', "Help Topics");
    pageTitleMaps.set('helpmenus', "Help Menus");
    pageTitleMaps.set('accountverification', "Account Verification");
    pageTitleMaps.set('transactionallocation', "Transaction Allocation");
    pageTitleMaps.set('tags', "Tags");
    pageTitleMaps.set('bravohierarchy', "Bravo Hierarchy");
    pageTitleMaps.set('customers', "Customers");
    pageTitleMaps.set('customeraccount', "Customer Account");

    return pageTitleMaps.get(masterName);
}

export function GetValidatedComponent({ value: cellvalue }) {
    if (cellvalue === 1) {
        return (
            <IconButton> <Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="success.main" /></IconButton>
        );
    }

    if (cellvalue === 2) {
        return (
            <IconButton><Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="#ffcd38" /></IconButton>

        );
    }
    if (cellvalue === 3) {
        return (
            <IconButton><Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="#9e9e9e" /></IconButton>

        );
    }
    if (cellvalue === 4) {
        return (
            <IconButton><Iconify icon="octicon:dot-fill-16" width='20px' height='20px' color="error.main" /></IconButton>

        );
    }
    GetValidatedComponent.propTypes = {
        value: PropTypes.number.isRequired,
    };
    //  if (cellvalue === "5") {
    //    return (
    //         <IconButton><Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="error.main" /></IconButton>

    //         );
    //  }
    //  return (
    //    <IconButton><Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="success.main" /></IconButton>

    //  );
    /*  <IconButton><Iconify icon={ICONS.error} width='25px' height='25px' color="error.main" /></IconButton> */
}


